var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 25,
    viewBox: "0 0 30 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.8502 6.4501L15.3002 0.350098L4.74023 6.4501V18.6301L15.3002 24.7301L25.8502 18.6301V6.4501Z",
    fill: "#4F80DD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.12043 4.50024H4.72043V4.26024C4.72043 3.40024 4.10043 2.62024 3.24043 2.53024C2.26043 2.43024 1.43043 3.20024 1.43043 4.17024V4.50024H1.03043C0.700426 4.50024 0.44043 4.76024 0.44043 5.09024V5.23024C0.44043 5.56024 0.700426 5.82024 1.03043 5.82024H1.43043V21.1502C1.43043 21.5902 1.79043 21.9402 2.22043 21.9402H3.92043C4.36043 21.9402 4.71043 21.5802 4.71043 21.1502V5.82024H5.11043C5.44043 5.82024 5.70042 5.56024 5.70042 5.23024V5.09024C5.70042 4.76024 5.44043 4.50024 5.11043 4.50024H5.12043Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.14 4.50024H28.74V4.26024C28.74 3.40024 28.12 2.62024 27.26 2.53024C26.28 2.43024 25.45 3.20024 25.45 4.17024V4.50024H25.05C24.72 4.50024 24.46 4.76024 24.46 5.09024V5.23024C24.46 5.56024 24.72 5.82024 25.05 5.82024H25.45V21.1502C25.45 21.5902 25.81 21.9402 26.24 21.9402H27.94C28.38 21.9402 28.73 21.5802 28.73 21.1502V5.82024H29.13C29.46 5.82024 29.72 5.56024 29.72 5.23024V5.09024C29.72 4.76024 29.46 4.50024 29.13 4.50024H29.14Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4497 20.9501L8.94968 19.3801C8.24968 19.3801 7.67969 18.8101 7.67969 18.1101V6.17015C7.67969 5.47015 8.24968 4.90015 8.94968 4.90015L25.4497 6.47015V20.9501Z",
    stroke: "black",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6504 5.09009V19.7101",
    stroke: "black",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6104 5.1001V19.8201",
    stroke: "black",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5703 5.62012V19.9501",
    stroke: "black",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5303 6.15015V20.4801",
    stroke: "black",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4902 6.15015V20.4801",
    stroke: "black",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M7.75 8.9502L25.5 10.8202",
    stroke: "black",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGate);
export default __webpack_public_path__ + "static/media/gate.589b0cc0.svg";
export { ForwardRef as ReactComponent };